import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ManageBidInstructionService } from '../manage-bid-instruction.service';

@Component({
  selector: 'app-add-bid-instruction',
  templateUrl: './add-bid-instruction.component.html',
  styleUrls: ['./add-bid-instruction.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ManageBidInstructionService]
})

export class AddBidInstructionComponent implements OnInit {

  @Output() cancelAddEvent = new EventEmitter<boolean>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();
  @Output() objMessage = new EventEmitter<{}>();
  @Output() reload = new EventEmitter<boolean>();

  processing = false;
  statePlaceholder = "Select One";
  trusteePlaceholder = "Select One";
  states : any [];
  trustees = [];
  uploadedFiles: any[] = [];
  bidInstructionFilename = 'Blank_Document.docx';
  uploadedFileName = '';
  excludeTrusteeList : boolean =true;
  
  /* ----- Form Groups and Controls ----*/
  public addBidInstructionForm: FormGroup = new FormGroup({
    State: new FormControl('', [Validators.required]),
    Trustee: new FormControl('', [Validators.required]),
    BidInstrDocIncluded: new FormControl('', [Validators.required]),
    AltisourceBidSheetIncluded: new FormControl('', [Validators.required]),
    SaleCertfBuyerCopyIncluded: new FormControl('', [Validators.required]),
    SaleCertfAltisourceCopyIncluded: new FormControl('', [Validators.required])
  });
  stateControl = this.addBidInstructionForm.get('State');
  trusteeControl = this.addBidInstructionForm.get('Trustee');
  bidInstrDocIncludedControl = this.addBidInstructionForm.get('BidInstrDocIncluded');
  altisourceBidSheetIncludedControl = this.addBidInstructionForm.get('AltisourceBidSheetIncluded');
  saleCertfBuyerCopyIncludedControl = this.addBidInstructionForm.get('SaleCertfBuyerCopyIncluded');
  saleCertfAltisourceCopyIncludedControl = this.addBidInstructionForm.get('SaleCertfAltisourceCopyIncluded');

  constructor(private manageBidInstructionService: ManageBidInstructionService) { }

  ngOnInit() { 
    this.getAllStates();
  }

   getAllStates(): any {
    this.statePlaceholder = "Loading..";
    this.stateControl.disable();

    this.manageBidInstructionService.getStates()
      .subscribe((statesData: any) => {
        this.statePlaceholder = "Select One";
        this.stateControl.enable();
        this.states = statesData.filter( (objState) => {
            return objState.value !== 'ALL';
        });
      }
      , (error) => {
        this.objMessage.emit({'severity': 'error', 'message':'Couldnot load states'});
        throw new Error('Could not load states.');
      });
   }


  getAvailableTrustees(stateObj: {}): any { 
    this.trusteePlaceholder = "Loading..";
    this.trustees = [{'TrusteeId': 'Loading..', 'TrusteeName': 'Loading..'}]
    this.trusteeControl.disable();
    this.manageBidInstructionService.getAvailableTrustees(stateObj,true)
      .subscribe( (trusteesData: any) => {
        this.trusteeControl.enable();
        this.trusteePlaceholder = "Select One";
        this.trustees = (<any>trusteesData).data;
      }
      , (error) => {
        this.objMessage.emit({'severity': 'error', 'message':'Couldnot load trustees'});
        throw new Error('Could not load trustees.');
      });
   }

  downloadBidInstructionFile(BidMatrixId?: any): any {
    let stInfo = this.manageBidInstructionService.downloadBidInstructionFile(BidMatrixId);
    stInfo.then( (data) => {
      if (!data.success) {
        this.objMessage.emit({'severity': 'error', 'detail': data.message});
      }
    });

  }

  submitInstructionForm(): any {
    this.processing = true;
    const bidInstructionPayLoad = {};
    bidInstructionPayLoad['StateCode'] = this.stateControl.value;
    bidInstructionPayLoad['TrusteeId'] = this.trusteeControl.value.TrusteeId;
    bidInstructionPayLoad['BidInstructionDocsIncluded'] = this.bidInstrDocIncludedControl.value;
    bidInstructionPayLoad['COSAltisourceCopyIncluded'] = this.altisourceBidSheetIncludedControl.value;
    bidInstructionPayLoad['COSBuyerCopyIncluded'] = this.saleCertfBuyerCopyIncludedControl.value;
    bidInstructionPayLoad['AltisourceBidSheetIncluded'] = this.saleCertfAltisourceCopyIncludedControl.value;    
    
    this.manageBidInstructionService.save(bidInstructionPayLoad, this.uploadedFiles)
      .subscribe((uploadData): any => {
        this.processing = false;
        this.uploadedFiles.length = 0;
        this.objMessage.emit({'severity': 'success', 'detail': 'Bid instruction added successfully.'});
        this.cancelAddEvent.emit(false);
        this.setBreadCrumbs.emit([{ label: 'Manage Bid Instruction' }]);
        this.reload.emit(true);
      },
      error => {
        this.processing = false;   
        this.objMessage.emit({'severity': 'error', 'detail': error.message});  
      });
  }

  hideAddBidForm(): void {
    this.cancelAddEvent.emit(false);
    this.reload.emit(false);
    this.setBreadCrumbs.emit([{ label: 'Manage Bid Instruction' }]);
  }

  onUpload(event) {
    for(let file of event.files) {
        this.uploadedFiles.push(file)
    }    
    this.uploadedFileName = this.uploadedFiles[0].name;
  }

  clearUploadedFile (): void {
    this.uploadedFiles.length = 0;
    this.uploadedFileName = ''
  }


}